import { ref, nextTick } from 'vue';
import bgTopRight from '../../../images/bg-symbol--top-right.svg';
export default {
  name: 'VideoSection',
  props: {
    heading: String,
    video: String,
    fullVideo: String,
    bgColor: {
      type: String,
      default: 'transparent'
    },
    blockId: {
      type: String,
      required: true
    },
    stairs: Boolean,
    textColor: Boolean,
    section: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const isDialogOpen = ref(false);
    const fullVideoPlayer = ref({});
    const openDialog = () => {
      isDialogOpen.value = true;
    };
    const playVideo = () => {
      nextTick(() => {
        const player = fullVideoPlayer.value[`fullVideoPlayer_${props.blockId}`];
        if (player) player.play();
      });
    };
    const pauseVideo = () => {
      nextTick(() => {
        const player = fullVideoPlayer.value[`fullVideoPlayer_${props.blockId}`];
        if (player) {
          player.pause();
          player.currentTime = 0;
        }
      });
    };
    return {
      isDialogOpen,
      fullVideoPlayer,
      openDialog,
      playVideo,
      pauseVideo,
      bgTopRight
    };
  }
};